export function includes<T, U extends T>(arr: readonly U[], elem: U): elem is U {
    return arr.includes(elem);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasKey<O>(obj: O, key: keyof any): key is keyof O {
    return obj !== null && typeof obj === 'object' && key in obj;
}

export function filterFalsy<T>(value: T | null | number | undefined | string): value is T {
    return (
        value !== null &&
        typeof value !== 'undefined' &&
        value !== 0 &&
        value !== '' &&
        !Number.isNaN(value as number)
    );
}
